import { BrowserModule, Title }  from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { FileSelectDirective } from 'ng2-file-upload';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { LoginComponent } from './login/login.component';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { CRespuestaService } from './login/shared/CRespuesta.service';
import { MatNativeDateModule, MatTableModule, MatPaginatorModule, MatSortModule } from '@angular/material';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { FooterComponent } from './footer/footer.component';
import { InicioComponent } from './inicio/inicio.component';
import { CookieService } from 'ngx-cookie-service';
import { ComandaComponent } from './comanda/comanda.component';
import { MensajeErrorComponent } from './mensaje-error/mensaje-error.component';
import { DatePipe } from '@angular/common';
import { TurnosComponent } from './turnos/turnos.component';
import { InsertaTicketComponent } from './inserta-ticket/inserta-ticket.component';
import { LoginrecuperacionComponent } from './loginrecuperacion/loginrecuperacion.component';
import { CambiaContrasenaComponent } from './cambia-contrasena/cambia-contrasena.component';
import { ErrorWifiComponent } from './error-wifi/error-wifi.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    FooterComponent,
    InicioComponent,
    ComandaComponent,
    MensajeErrorComponent,
    TurnosComponent,
    InsertaTicketComponent,
    LoginrecuperacionComponent,
    CambiaContrasenaComponent,
    ErrorWifiComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CoreModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
  ],
  providers: [CRespuestaService,Title,CookieService,DatePipe],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }

platformBrowserDynamic().bootstrapModule(AppModule);
